import { ErrorPage } from "pages/InvalidStatePages/ErrorPage";
import React, { ReactNode } from "react";
import errorStore, { globalComponentName } from "stores/errorStore";

interface ErrorBoundaryProps {
  children: ReactNode;
  customErrorTitle?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
  componentKey?: string;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: any, errorInfo: React.ErrorInfo) {
    const componentKey = error?.componentKey ?? globalComponentName;

    errorStore.update((s) => {
      s[componentKey] = {
        ...error,
        ...errorInfo,
      };;
    });

    this.setState({ hasError: true, componentKey });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          componentKey={this.state.componentKey}
          customErrorTitle={this.props.customErrorTitle}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
